<template>
  <van-popup :value="value" @input="input" round :close-on-click-overlay="true" position="bottom" class="connect-status-wrap"
      :style="{'--placeHolderColor': placeHolderColor, '--rippleColor': rippleColor}">
    <div class="vertical items-center h-full">
      <div class="status" @click="switchStatus">{{ statusTitle }}</div>
      <div class="vertical items-center justify-center" style="height:100%;">
        <div class="ripple-container">
          <div class="ripple"></div>
          <div class="ripple"></div>
          <div class="ripple"></div>
          <div class="ripple"></div>
          <div class="place-holder">
            <van-image v-if="status > 0" :src="statusIcon"/>
          </div>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: "ConnectStatusPopup",
  props: {
    status: {
      type: Number, //  0 connecting 1connected  2:fail 3:disconnect
      require: true
    },
    value: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      color: "#87EBA2",
      successIcon: require("@/assets/icons/v2/ic_success_connect.svg"),
      failIcon: require("@/assets/icons/v2/ic_fail_connect.svg"),
      statusIcon: null,
      placeHolderColor: "#87EBA2",
      rippleColor: "rgba(106,239,164,0.3)",
      statusTitle: "Connecting"
    };
  },
  methods: {
    input(e) {
      this.$emit("input", e);
    },
    switchStatus() {
      const status = this.status + 1;
      console.log(status % 4);
      this.status = status % 4;
    }
  },
  watch: {
    status(val) {
      switch (val) {
        case 0:
          this.statusTitle = "Connecting";
          this.statusIcon = this.successIcon;
          this.placeHolderColor = "#87EBA2";
          this.rippleColor = "rgba(106,239,164,0.3)";
          break;
        case 1:
          this.statusTitle = "Connected";
          this.statusIcon = this.successIcon;
          this.placeHolderColor = "#87EBA2";
          this.rippleColor = "rgba(106,239,164,0.3)";
          break;
        case 2:
          this.statusTitle = "Connection Failure";
          this.statusIcon = this.failIcon;
          this.placeHolderColor = "#FF8888";
          this.rippleColor = "rgba(255,136,136,0.3)";
          break;
        case 3:
          this.statusTitle = "Disconnect";
          this.statusIcon = this.failIcon;
          this.placeHolderColor = "#FF8888";
          this.rippleColor = "rgba(255,136,136,0.3)";
          break;
      }
    }
  },
  computed: {}
};
</script>


<style scoped lang="less">
.connect-status-wrap {
  width: 100%;
  height:403px;
  padding: 24px;
}

.status {
  font-size: 16px;
  font-weight: 500;
}

.place-holder {
  position: absolute;
  width: 90px;
  height: 90px;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  background: var(--placeHolderColor);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.ripple-container {
  position: relative;
  width: 160px;
  height: 160px;
  overflow: hidden;
}

.ripple {
  position: absolute;
  border-radius: 50%;
  width: 90px;
  height: 90px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  background: var(--rippleColor);
  animation: ripple-animation 2s linear infinite;
  -webkit-backface-visibility: hidden;
  overflow: hidden;
}

.ripple:nth-child(2) {
  animation-delay: 0.5s;
}

.ripple:nth-child(3) {
  animation-delay: 1s;
}

@keyframes ripple-animation {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1.777);
    opacity: 0;
  }
}

</style>